import React, { useState, useContext, useEffect, Fragment } from "react";

import { UrlServicesContext } from "components/UrlServicesContext";
import { makeStyles } from "@mui/styles";
import { DataGrid, GridActionsCellItem, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import clsx from "clsx";
import {
  Grid,
  Tooltip,
  Box,
  Alert,
  TextField,
  InputAdornment,
} from "@mui/material";
import {
  Cancel,
  List,
  Add,
  AddCircle,
  Edit,
  Search,
} from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";
import {
  cardBodyStyle,
  ButtonStyle0,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

import NewAdvisorAdmin from "views/dialog/NewAdvisorAdmin";
import EditAdvisorAdmin from "views/dialog/EditAdvisorAdmin";
import StatusAdmin from "views/dialog/StatusAdmin";

const useStyles = makeStyles(cardBodyStyle);

export default function AdvisorsListAdmin() {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [idRow, setIdRow] = useState("");
  const [openNew, setOpenNew] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [searchText, setSearchText] = useState("");

  const { urlServices, UserAuth } = useContext(UrlServicesContext);
  const keyAuthorization = UserAuth.Session;

  const filteredRows = rows.filter((row) =>
    row.name.toLowerCase().includes(searchText.toLowerCase()),
  );

  const columns = [
    {
      headerName: "Nombre",
      field: "name",
      flex: 1,
      headerClassName: "super-app-theme--header",
      cellClassName: (params) => clsx("super-app", { celAll: params.value }),
    },
    {
      headerName: "Estado",
      field: "status",
      headerAlign: "center",
      align: "center",
      width: 120,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const isActive = parseInt(params.value) === 1;
        return (
          <b style={{ color: isActive ? "green" : "red", fontSize: 10 }}>
            {isActive ? "ACTIVO" : "INACTIVO"}
          </b>
        );
      },
    },
    {
      headerName: "Acciones",
      field: "actions",
      type: "actions",
      width: 110,
      headerClassName: "super-app-theme--header",
      cellClassName: (params) =>
        clsx("super-app", { celActions: params.value }),
      getActions: (params) => [
        <GridActionsCellItem
          key="edit"
          icon={
            <Tooltip title="Editar" arrow>
              <Edit style={{ fontSize: 24, color: "#000" }} />
            </Tooltip>
          }
          label="Editar"
          onClick={() => {
            setIdRow(params);
            setOpenEdit(true);
          }}
        />,
        parseInt(params.row.status) === 0 ? (
          <GridActionsCellItem
            key="enable"
            icon={
              <Tooltip title="Habilitar" arrow>
                <AddCircle style={{ fontSize: 24, color: "green" }} />
              </Tooltip>
            }
            label="Habilitar"
            onClick={() => {
              setIdRow(params);
              setOpenStatus(true);
            }}
          />
        ) : (
          <GridActionsCellItem
            key="disable"
            icon={
              <Tooltip title="Deshabilitar" arrow>
                <Cancel style={{ fontSize: 24, color: "#000" }} />
              </Tooltip>
            }
            label="Deshabilitar"
            onClick={() => {
              setIdRow(params);
              setOpenStatus(true);
            }}
          />
        ),
      ],
    },
  ];

  const RefreshTable = async () => {
    setLoader(true);
    try {
      const response = await axios.get(`${urlServices}advisor/list`, {
        headers: { Authorization: `Bearer ${keyAuthorization}` },
      });
      setRows(response.data);
    } catch (e) {
      if (e.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
      } else {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RefreshTable();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes.cardTitleBlack}>
          <List className={classes.iconFilter} /> Listado de asesores
        </div>
        <Card>
          <CardBody>
            {error && <Alert severity="error">{mensageSystem}</Alert>}
            {loader ? (
              <Grid container>
                <Grid item xs={12}>
                  <center>
                    <img
                      src={loaderGif}
                      alt="loader"
                      style={{ width: 60, margin: "20% 0" }}
                    />
                  </center>
                </Grid>
              </Grid>
            ) : (
              <Fragment>
                <Grid container>
                  <Grid item xs={12}>
                    <div style={{ float: "right" }}>
                      <ButtonStyle0
                        onClick={() => setOpenNew(true)}
                        endIcon={<Add />}
                      >
                        Agregar asesor
                      </ButtonStyle0>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} sx={{ mt: 1 }}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Buscar asesor..."
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      autoComplete="off"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search style={{ color: "gray", fontSize: 20 }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  {filteredRows.length > 0 ? (
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          "& .super-app.celAll": { fontSize: 12 },
                          "& .super-app.celActions": {
                            backgroundColor: "rgb(242, 242, 242)",
                          },
                          "& .super-app-theme--header": {
                            backgroundColor: "rgb(242, 242, 242)",
                          },
                          marginTop: 2,
                        }}
                      >
                        <DataGrid
                          rows={filteredRows}
                          columns={columns}
                          initialState={{
                            pagination: {
                              paginationModel: { page: 0, pageSize: 10 },
                            },
                          }}
                          pageSizeOptions={[5, 10, 20, 50]}
                          disableRowSelectionOnClick
                          checkboxSelection={false}
                          sx={{
                            [`& .${gridClasses.cell}`]: {
                              display: "flex",
                              alignItems: "center",
                            },
                          }}
                          getRowHeight={() => "auto"}
                          autoWidth
                        />
                      </Box>
                    </Grid>
                  ) : (
                    <Grid item xs={12}>
                      <center>
                        <img
                          src={noDataImg}
                          alt="no data"
                          style={{ width: 300, marginTop: 50 }}
                        />
                        <br />
                        <b style={{ fontSize: 18, margin: "5px 0 70px 0" }}>
                          No hay registros para mostrar
                        </b>
                      </center>
                    </Grid>
                  )}
                </Grid>
              </Fragment>
            )}
          </CardBody>
        </Card>
      </GridItem>

      {openNew && (
        <NewAdvisorAdmin
          open={openNew}
          exit={() => setOpenNew(false)}
          callBackRefresh={RefreshTable}
        />
      )}
      {openEdit && (
        <EditAdvisorAdmin
          open={openEdit}
          exit={() => setOpenEdit(false)}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
      {openStatus && (
        <StatusAdmin
          open={openStatus}
          exit={() => setOpenStatus(false)}
          id={idRow}
          callBackRefresh={RefreshTable}
          path="advisor"
        />
      )}
    </GridContainer>
  );
}
